import PropTypes from 'prop-types';
import { IconJsxer } from '../../helpers/IconHelper';
import './FeatureChainStepHeader.scss';

const FeatureChainStepHeader = ({
    stepNumber,
    title,
    enabled,
    isActive,
    showToggle,
    canToggle,
    onToggle,
}) => {
    const toggleLabel = enabled ? 'Disable step' : 'Enable step';

    return (
        <div className={`feature-chain-step-header-card${isActive ? ' is-active' : ''}`}>
            <div className="feature-chain-step-header-main">
                <div className={`feature-chain-step-badge${enabled ? ' is-enabled' : ''}${isActive ? ' is-active' : ''}`}>
                    {stepNumber}
                </div>
                <div className="feature-chain-step-header-copy">
                    <div className="feature-chain-step-title">{title}</div>
                </div>
            </div>
            {showToggle &&
                <div className="feature-chain-step-header-actions" onClick={(e) => e.stopPropagation()}>
                    <button
                        type="button"
                        className={`feature-chain-step-header-action${enabled ? ' is-enabled' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (canToggle) {
                                onToggle?.(e);
                            }
                        }}
                        disabled={!canToggle}
                        aria-label={toggleLabel}
                        title={toggleLabel}
                    >
                        {IconJsxer.GetIcon(IconJsxer.ICONS.powerOff, IconJsxer.ICON_STYLES.campaignPanelInfoPill)}
                    </button>
                </div>
            }
        </div>
    );
};

FeatureChainStepHeader.propTypes = {
    stepNumber: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    enabled: PropTypes.bool,
    isActive: PropTypes.bool,
    showToggle: PropTypes.bool,
    canToggle: PropTypes.bool,
    onToggle: PropTypes.func,
};

FeatureChainStepHeader.defaultProps = {
    enabled: true,
    isActive: false,
    showToggle: true,
    canToggle: false,
    onToggle: null,
};

export default FeatureChainStepHeader;